import React from "react";
import { Marker as MapMarker } from "react-map-gl";
import poiIcon from "./assets/poi.svg";

const Marker = ({ position, name, children }) => (
    <MapMarker latitude={position.lat} longitude={position.lng}>
      {children || (
        <div style={{ textAlign: "center" }}>
          <img src={poiIcon} alt="POI Icon" style={{ width: "24px", height: "24px" }} />
          {name && <div>{name}</div>}
        </div>
      )}
    </MapMarker>
  );

export default Marker;
